import React, { useContext } from 'react';

import './loadingSpinner.scss'

const LoadingSpinner = ({size, color}: {size: number, color?: string}) => {

    return <div className="lds-spinner" data-testid="lds-spinner" style={{height:`${size}px`, width: `${size}px`, margin: '8px auto'}}><div /><div /><div /><div /><div /><div /><div /><div /></div>
}

export default LoadingSpinner